import './search.css';
import '../listing/listing.css';
import '../illustration/illustration.css';
import '../biblio/biblio.css';
import '../dossier/dossier.css';
import '../dossier/dossier-titre.css';
import '../dossier/dossier-cartillu.css';
import '../dossier/dossier-somation.css';
import '../dossier/dossier-localisation.css';
import '../dossier/dossier-historique.css';
import '../dossier/dossier-description.css';
import '../dossier/dossier-actions.css';
import '../common/tablerixme.css';
import '../carousel/carousel.css';
import '../utils/utils.css';
import '../carto/carto.css';
import '../carto/ol-override.css';
import '../modal/modal.css';
import '../../node_modules/ol/ol.css';

import { init as initListing } from '../listing/listing.js';
import { manageSelectionLinkInHeader } from '../selection/utils.js';
import {
  initCheckBoxTous,
  initInputSearchFacette,
  initOnChangeFacette,
  initOnReset,
} from './search-utils.js';

const container = document.querySelector('.search-results');
const filtersButtons = document.querySelectorAll(
  '.filters [data-action="filters:toggle"]',
);

if (filtersButtons.length) {
  // Gestion de l'affichage des filtres
  filtersButtons.forEach((filtersButton) => {
    filtersButton.addEventListener('click', () => {
      const filtersStatus = container.getAttribute('data-filters');
      container.setAttribute(
        'data-filters',
        filtersStatus === 'opened' ? 'closed' : 'opened',
      );
    });
  });

  const filtersForm = document.querySelector('form.filters');

  if (filtersForm) {
    initOnReset(filtersForm, () => filtersForm.submit());

    initCheckBoxTous(filtersForm);

    initInputSearchFacette(filtersForm);

    initOnChangeFacette(filtersForm, function () {
      const serializedRechercheExperte =
        filtersForm.querySelector('input[name="q"')?.value;
      if (!serializedRechercheExperte) {
        filtersForm.submit();
        return;
      }

      // On ne submit pas le form mais on simule sa soumission
      // à cause de la recherche experte qui ne doit pas être url-encodée,
      // ce que le formulaire réalise automatiquement à sa soumission.
      // Et ajouter la recherche en queryparam dans l'action du form ne fonctionne pas.
      const formData = new FormData(filtersForm);
      formData.delete('q');
      const urlSearchParams = new URLSearchParams(formData);
      const queryParams = `q=${serializedRechercheExperte}&${urlSearchParams.toString()}`;
      location.search = queryParams;
    });

    initInputSearchFacette(filtersForm);
  }
}

initListing();

manageSelectionLinkInHeader();
